// This code is duplicative of contact.js, due to weird build shennanigans
export default {
    init() {
        let csrfToken;

        const getCsrfToken = () => {
            if (!csrfToken) {
                return fetch('/ajax/users/csrf')
                    .then((res) => {
                        if (!res.ok) throw Error(res.statusText);
                        return res;
                    })
                    .then((res) => res.json())
                    .then((data) => {
                        csrfToken = data.csrfToken;
                        return csrfToken;
                    });
            }
            return Promise.resolve(csrfToken);
        };

        const handleSubmit = (e) => {
            e.preventDefault();
            const form = e.target;
            const csrfInput = form.querySelector('.csrfToken');
            getCsrfToken().then((token) => {
                csrfInput.value = token;
                form.removeEventListener('submit', handleSubmit);
                form.requestSubmit();
            });
        };

        Array.from(document.getElementsByTagName('form')).forEach((form) => {
            form.addEventListener('submit', handleSubmit);
        });
    },
};
